const doc = [({"false":null, "no":({"js":({"routes":({"admin":({"notification_type_audit_triggers":({"edit":({})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;